import * as WebV2MovieDetails from "../web/v2/movie_details";

export default class DetailOpener {

    constructor(document, href) {
        this.document = document;
        this.url = new URL(href);
        this.param = this.url.searchParams.get("d");
        if ( this.param ) {
            try {
                this.data = JSON.parse( atob( this.param.split("").reverse().join("") ) );
                this.run();
            } catch (e) {
                console.log(e)
            }
        }
    }

    run() {
        if ( this.data ) {
            let link = this.document.createElement( 'a' );
            link.dataset['id'] = this.data['id'];
            link.dataset['kind'] = this.data['kind'];
            link.classList.add( 'trigger-detail' );
            link.classList.add( 'd-none' );
            link.href = 'javascript: void(0);';
            link.addEventListener("click", (e) => {
                WebV2MovieDetails.displayModal();
                WebV2MovieDetails.initModalMovieDetails(link);
            });

            link.classList.add( 'bound' );

            this.document.body.appendChild( link );
            link.click();
        }
    }
}
